import { AppBar, IconButton, Toolbar, Typography } from "@mui/material";
import { Menu } from "@mui/icons-material";
import dashboardStyle from "./DashboardStyle";

export default function Header({ mobileOpen, setMobileOpen }) {
  const classes = dashboardStyle();
  return (
    <AppBar position="fixed" className={classes.AppBar}>
      <Toolbar>
        <IconButton
          onClick={() => setMobileOpen(!mobileOpen)}
          color="inherit"
          edge="start"
          className={classes.menuButton}
        >
          <Menu />
        </IconButton>
        <Typography variant="h6">Material-UI</Typography>
      </Toolbar>
    </AppBar>
  );
}
